import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Works from '../views/Works.vue'
import Company from '../views/Company.vue'
import Access from '../views/Access.vue'
import Yorozu from '../views/Yorozu.vue'
import YorozuWorks from '../views/YorozuWorks.vue'
import Privacy from '../views/Privacy.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/works.html',
    name: 'works',
    meta: {
      title: 'WORKS'
    },
    component: Works
  },
  {
    path: '/company.html',
    name: 'company',
    meta: {
      title: 'COMPANY'
    },
    component: Company
  },
  {
    path: '/access.html',
    name: 'access',
    meta: {
      title: 'ACCESS'
    },
    component: Access
  },
  {
    path: '/yorozu/index.html',
    name: 'yorozu',
    meta: {
      title: 'YOROZU'
    },
    component: Yorozu
  },
  {
    path: '/yorozu/works.html',
    name: 'yorozu-works',
    meta: {
      title: 'WORKS | YOROZU'
    },
    component: YorozuWorks
  },
  {
    path: '/privacypolicy.html',
    name: 'privacy',
    meta: {
      title: 'PRIVACY POLICY'
    },
    component: Privacy
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'current',
  linkExactActiveClass: '',
  routes
})

export default router
